// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Result from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CorePricingUtils from "../../../../library/utils/CorePricingUtils.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PricingDashboardConfig from "../../../../library/utils/PricingDashboardConfig.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";
import * as PricingDashboardAssetsManager from "../../../../../assets/PricingDashboardAssetsManager.bs.js";

var cross_icon = PricingDashboardAssetsManager.getImage("cross-icon.svg");

var info_icon = PricingDashboardAssetsManager.getImage("info-icon.svg");

var validators_price_per_km = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: param.price_per_km
                    }), (function (price) {
                    if (price < 0.0 || price > PricingDashboardConfig.slab_price_per_km_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 100"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: price
                            };
                    }
                  }));
    })
};

var validators_price_per_min = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: param.price_per_min
                    }), (function (price) {
                    if (price < 0.0 || price > PricingDashboardConfig.slab_price_per_min_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 25"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: price
                            };
                    }
                  }));
    })
};

var validators_end_distance = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var start_distance = param.start_distance;
      return Belt_Result.flatMap(CorePricingUtils.getIntValue(param.end_distance), (function (distance) {
                    if (distance < 0 || distance > PricingDashboardConfig.max_end_distance) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 9999"
                            };
                    } else if (FormValidationUtils$Catalyst.isIntegerStringValid(start_distance) && Caml_format.caml_int_of_string(start_distance) >= distance) {
                      return {
                              TAG: /* Error */1,
                              _0: "Distance range is invalid"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: distance
                            };
                    }
                  }));
    })
};

var validators_start_distance = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var end_distance = param.end_distance;
      return Belt_Result.flatMap(CorePricingUtils.getIntValue(param.start_distance), (function (distance) {
                    if (distance < 0 || distance > PricingDashboardConfig.max_end_distance) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 9999"
                            };
                    } else if (FormValidationUtils$Catalyst.isIntegerStringValid(end_distance) && Caml_format.caml_int_of_string(end_distance) <= distance) {
                      return {
                              TAG: /* Error */1,
                              _0: "Invalid Distance Range"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: distance
                            };
                    }
                  }));
    })
};

var validators = {
  price_per_km: validators_price_per_km,
  price_per_min: validators_price_per_min,
  end_distance: validators_end_distance,
  start_distance: validators_start_distance
};

function initialFieldsStatuses(_input) {
  return {
          price_per_km: /* Pristine */0,
          price_per_min: /* Pristine */0,
          end_distance: /* Pristine */0,
          start_distance: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            price_per_km: /* Pristine */0,
            price_per_min: /* Pristine */0,
            end_distance: /* Pristine */0,
            start_distance: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.price_per_km;
  var match_0 = match ? match._0 : Curry._1(validators.price_per_km.validate, input);
  var match$1 = fieldsStatuses.price_per_min;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.price_per_min.validate, input);
  var match$2 = fieldsStatuses.end_distance;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.end_distance.validate, input);
  var match$3 = fieldsStatuses.start_distance;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.start_distance.validate, input);
  var price_per_kmResult = match_0;
  var price_per_kmResult$1;
  if (price_per_kmResult.TAG === /* Ok */0) {
    var price_per_minResult = match_0$1;
    if (price_per_minResult.TAG === /* Ok */0) {
      var end_distanceResult = match_0$2;
      if (end_distanceResult.TAG === /* Ok */0) {
        var start_distanceResult = match_0$3;
        if (start_distanceResult.TAG === /* Ok */0) {
          return {
                  TAG: /* Valid */0,
                  output: {
                    start_distance: start_distanceResult._0,
                    end_distance: end_distanceResult._0,
                    price_per_min: price_per_minResult._0,
                    price_per_km: price_per_kmResult._0
                  },
                  fieldsStatuses: {
                    price_per_km: /* Dirty */{
                      _0: price_per_kmResult,
                      _1: /* Shown */0
                    },
                    price_per_min: /* Dirty */{
                      _0: price_per_minResult,
                      _1: /* Shown */0
                    },
                    end_distance: /* Dirty */{
                      _0: end_distanceResult,
                      _1: /* Shown */0
                    },
                    start_distance: /* Dirty */{
                      _0: start_distanceResult,
                      _1: /* Shown */0
                    }
                  },
                  collectionsStatuses: undefined
                };
        }
        price_per_kmResult$1 = price_per_kmResult;
      } else {
        price_per_kmResult$1 = price_per_kmResult;
      }
    } else {
      price_per_kmResult$1 = price_per_kmResult;
    }
  } else {
    price_per_kmResult$1 = price_per_kmResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            price_per_km: /* Dirty */{
              _0: price_per_kmResult$1,
              _1: /* Shown */0
            },
            price_per_min: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            end_distance: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            start_distance: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurPrice_per_kmField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.price_per_km, validators_price_per_km, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  price_per_km: status,
                                  price_per_min: init.price_per_min,
                                  end_distance: init.end_distance,
                                  start_distance: init.start_distance
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPrice_per_minField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.price_per_min, validators_price_per_min, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  price_per_km: init.price_per_km,
                                  price_per_min: status,
                                  end_distance: init.end_distance,
                                  start_distance: init.start_distance
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEnd_distanceField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.end_distance, validators_end_distance, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  price_per_km: init.price_per_km,
                                  price_per_min: init.price_per_min,
                                  end_distance: status,
                                  start_distance: init.start_distance
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStart_distanceField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.start_distance, validators_start_distance, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  price_per_km: init.price_per_km,
                                  price_per_min: init.price_per_min,
                                  end_distance: init.end_distance,
                                  start_distance: status
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */4 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */4,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */5,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */7);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */6);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */5 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */6 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */7 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdatePrice_per_kmField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.price_per_km, state.submissionStatus, validators_price_per_km, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            price_per_km: status,
                                            price_per_min: init.price_per_min,
                                            end_distance: init.end_distance,
                                            start_distance: init.start_distance
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePrice_per_minField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.price_per_min, state.submissionStatus, validators_price_per_min, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            price_per_km: init.price_per_km,
                                            price_per_min: status,
                                            end_distance: init.end_distance,
                                            start_distance: init.start_distance
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEnd_distanceField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$4 = Formality.validateDependentFieldOnChange(nextInput$2, nextFieldsStatuses.contents.start_distance, validators_start_distance, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  price_per_km: init.price_per_km,
                                  price_per_min: init.price_per_min,
                                  end_distance: init.end_distance,
                                  start_distance: status
                                };
                        }));
                  if (result$4 !== undefined) {
                    nextFieldsStatuses.contents = result$4;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, nextFieldsStatuses.contents.end_distance, state.submissionStatus, validators_end_distance, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            price_per_km: init.price_per_km,
                                            price_per_min: init.price_per_min,
                                            end_distance: status,
                                            start_distance: init.start_distance
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStart_distanceField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.start_distance, state.submissionStatus, validators_start_distance, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            price_per_km: init.price_per_km,
                                            price_per_min: init.price_per_min,
                                            end_distance: init.end_distance,
                                            start_distance: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */4 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                price_per_km: /* Pristine */0,
                                price_per_min: /* Pristine */0,
                                end_distance: /* Pristine */0,
                                start_distance: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                price_per_km: /* Pristine */0,
                                price_per_min: /* Pristine */0,
                                end_distance: /* Pristine */0,
                                start_distance: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */5 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */6 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updatePrice_per_km: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePrice_per_kmField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updatePrice_per_min: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePrice_per_minField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEnd_distance: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEnd_distanceField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStart_distance: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStart_distanceField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurPrice_per_km: (function (param) {
              return Curry._1(dispatch, /* BlurPrice_per_kmField */0);
            }),
          blurPrice_per_min: (function (param) {
              return Curry._1(dispatch, /* BlurPrice_per_minField */1);
            }),
          blurEnd_distance: (function (param) {
              return Curry._1(dispatch, /* BlurEnd_distanceField */2);
            }),
          blurStart_distance: (function (param) {
              return Curry._1(dispatch, /* BlurStart_distanceField */3);
            }),
          price_per_kmResult: Formality.exposeFieldResult(state.fieldsStatuses.price_per_km),
          price_per_minResult: Formality.exposeFieldResult(state.fieldsStatuses.price_per_min),
          end_distanceResult: Formality.exposeFieldResult(state.fieldsStatuses.end_distance),
          start_distanceResult: Formality.exposeFieldResult(state.fieldsStatuses.start_distance),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.price_per_km || match.price_per_min || match.end_distance || match.start_distance) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */4);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */5);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */6);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */6,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */7);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function SlabForm(Props) {
  var slab_data = Props.slab_data;
  var isSubmitted = Props.isSubmitted;
  var onChange = Props.onChange;
  var removeSlab = Props.removeSlab;
  var start_distance = Props.start_distance;
  var form = useForm({
        start_distance: start_distance,
        end_distance: slab_data.end_distance,
        price_per_min: slab_data.price_per_min,
        price_per_km: slab_data.price_per_km
      }, (function (param, param$1) {
          
        }));
  React.useEffect((function () {
          Curry._5(onChange, slab_data.id, form.input.end_distance, form.input.price_per_min, form.input.price_per_km, Curry._1(form.valid, undefined));
          
        }), [form.input]);
  React.useEffect((function () {
          Curry._2(form.updateStart_distance, (function (input, _value) {
                  return {
                          start_distance: start_distance,
                          end_distance: input.end_distance,
                          price_per_min: input.price_per_min,
                          price_per_km: input.price_per_km
                        };
                }), "");
          Curry._5(onChange, slab_data.id, form.input.end_distance, form.input.price_per_min, form.input.price_per_km, Curry._1(form.valid, undefined));
          
        }), [start_distance]);
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  return React.createElement("div", {
              key: slab_data.id,
              className: "slab " + (
                isSubmitted && !slab_data.isValid ? "error-slab" : ""
              )
            }, React.createElement(Row$Catalyst.make, {
                  children: null,
                  className: "slab-header"
                }, React.createElement("div", {
                      className: "title"
                    }, "Slab " + String(slab_data.slab_no + 1 | 0)), React.createElement("div", {
                      className: "remove-slab",
                      onClick: (function (param) {
                          return Curry._1(removeSlab, slab_data.id);
                        })
                    }, React.createElement("img", {
                          src: cross_icon
                        }), "Remove")), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Distance Range",
                      unit: "kms"
                    }), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function (_event) {
                              
                            }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: start_distance
                      }
                    }), React.createElement("div", {
                      className: "label"
                    }, "to"), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updateEnd_distance, (function (input, value) {
                                            return {
                                                    start_distance: input.start_distance,
                                                    end_distance: value,
                                                    price_per_min: input.price_per_min,
                                                    price_per_km: input.price_per_km
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.end_distanceResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.end_distance
                      }
                    })), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Price per KM",
                      unit: currency
                    }), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updatePrice_per_km, (function (input, value) {
                                            return {
                                                    start_distance: input.start_distance,
                                                    end_distance: input.end_distance,
                                                    price_per_min: input.price_per_min,
                                                    price_per_km: value
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.price_per_kmResult, undefined, undefined, undefined, {
                            TAG: /* Text */0,
                            _0: "Enter values between 0 and 100"
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.price_per_km
                      }
                    })), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Price per min",
                      unit: currency
                    }), React.createElement(FormTextInput$Catalyst.make, {
                      input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                              return Curry._2(form.updatePrice_per_min, (function (input, value) {
                                            return {
                                                    start_distance: input.start_distance,
                                                    end_distance: input.end_distance,
                                                    price_per_min: value,
                                                    price_per_km: input.price_per_km
                                                  };
                                          }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                            }), undefined, undefined, undefined, undefined, undefined, undefined, form.price_per_minResult, undefined, undefined, undefined, {
                            TAG: /* Text */0,
                            _0: "Enter values between 0 and 25"
                          }, undefined, undefined, undefined, undefined, undefined),
                      textinput_props: {
                        value: form.input.price_per_min
                      }
                    })));
}

var make = SlabForm;

export {
  cross_icon ,
  info_icon ,
  Form ,
  make ,
  
}
/* cross_icon Not a pure module */
